import { useAppConfig } from 'src/utils/appConfig/useAppConfig';
import { getMessage, MESSAGE_KEYS } from '../../../fixtures/client-only-l10n';
import ErrorLayout from '../../../layouts/ErrorLayout/ErrorLayout';

function InternalServerError() {
  const { defaultLanguage } = useAppConfig();

  const bigHeader = getMessage(defaultLanguage, MESSAGE_KEYS.ERROR_PAGE_500_BIG_HEADER);
  const message = getMessage(defaultLanguage, MESSAGE_KEYS.ERROR_PAGE_500_MESSAGE);
  const buttonMessage = getMessage(defaultLanguage, MESSAGE_KEYS.ERROR_PAGE_500_BUTTON_MESSAGE);

  return (
    <ErrorLayout
      imageSrc='/i/an-egg.png'
      imageAlt='An egg'
      smallHeader='500'
      bigHeader={bigHeader}
      message={message}
      buttonMessage={buttonMessage}
      buttonLink='/'
    />
  );
}

export default InternalServerError;
